<script setup lang="ts">
import type { CmsBlockGalleryBuybox } from "@shopware-pwa/composables-next";
import { useCmsBlock } from "#imports";

const props = defineProps<{
  content: CmsBlockGalleryBuybox;
}>();

const { getSlotContent } = useCmsBlock(props.content);
const rightContent = getSlotContent("right");
const leftContent = getSlotContent("left");
</script>

<template>
  <div class="product-detail-l px-4 !m-0">
    <div class="container mx-auto relative pt-6 pb-0 sm:pt-12 sm:pb-12">
      <div class="flex justify-between flex-wrap lg:flex-nowrap">
        <div
        class="mb-8 md:mb-0 w-full md:w-[100%] lg:w-[500px] xl:w-[590px]"
        >
          <CmsGenericElement :content="leftContent" />
        </div>
        <div class="w-full mt-12 lg:mt-0 lg:w-[460px] xl:w-[488px]">
          <CmsGenericElement :content="rightContent" />
        </div>
      </div>
    </div>
  </div>
</template>
